import { Component } from "react";

export class SafeBoundary extends Component {
  state = { err: null };
  static getDerivedStateFromError(err) { return { err }; }
  render() {
    if (!this.state.err) return this.props.children;
    return (
      <div data-testid="safe-boundary-error" className="rounded-sm border border-red-200 bg-red-50 p-4 text-sm text-red-700">
        Part of this kit's content couldn't be displayed ({String(this.state.err.message || this.state.err).slice(0, 140)}). The rest of the kit is safe — reload the page, or use Regenerate on the affected section.
      </div>
    );
  }
}
